import styled, { css } from 'styled-components';
import { IButtonStyled } from './../../../../common/interfaces/buttons';

export const StyledButton = styled.button<IButtonStyled>(
  ({ theme, padding, borderRadius }) => {
    return css`
      display: flex;
      align-items: center;
      justify-content: center;
      padding: ${padding};
      border: none;
      background-color: ${theme.colorToken.transparent};
      border-radius: ${borderRadius};
      cursor: pointer;
      gap: ${theme.spacing['8']};

      &:hover {
        background-color: ${theme.colorToken.interactiveLight};
      }
      &:active {
        background-color: ${theme.colorToken.borderInteractive};
      }
    `;
  }
);
